module.exports = __webpack_public_path__ + "media/images/beauty/pascaline@3x-236863991051f244602c643b67372c22.jpg";